<div class="modal-content">
  <ng-template vsfDialogTitle>{{ title }}</ng-template>

  <div class="modal-body text-left w-full mt-4 mb-4">
    <div
      class="prose max-w-none px-4"
      [innerHTML]="safeDescription"
    ></div>
  </div>

  <ng-template vsfDialogButtons>
    <div class="flex justify-center items-center">
      <p>(Click anywhere to close.)</p>
    </div>
  </ng-template>
</div>
